export function canFetchData(companyId, vendor, owner) {
  if (vendor !== 'aws' && vendor !== 'azure') {
    return false; // Not support vendor other than AWS and Azure now.
  }
  if (owner === 'taggroup') {
    return false; // Not support 'taggroup'.
  }
  return true;
}

export default {
  canFetchData: canFetchData,
};
